const API_CONFIG = {
  baseUrl: "https://shopify-search-engine-bruderer.shopify-apps.aico.swiss/api",
  endpoints: {
    search: "/search",
  },
  metafields: {
    allergens: "metafield_custom_fields_allergens",
    certificates: "metafield_custom_fields_product_certificates_list_v2",
    certificatesKey: "metafield_custom_fields_product_certificates_list_v2",
  },
  // Define which allergen values should be excluded (not included)
  excludeAllergens: new Set([
    "Milk",
    "Gluten cereals",
    "Soybeans",
    "Tree nuts"
  ]),
  getShop: function () {
    const gridElement = document.querySelector('api-collection-grid');
    if (gridElement) {
      const shop = gridElement.getAttribute('data-shop');
      return shop ? shop : "bruderer.myshopify.com";
    }
  },
  getCollection: function () {
    const gridElement = document.querySelector('api-collection-grid');
    if (gridElement) {
      const collection = gridElement.getAttribute('data-collection');
      if (collection) {
        return collection;
      }
    }

    const urlPath = window.location.pathname;
    const match = urlPath.match(/\/collections\/([^\/]+)/);
    return match ? match[1] : "all";
  },
  getLocale: function () {
    const gridElement = document.querySelector('api-collection-grid');
    if (gridElement) {
      const dataLocale  = gridElement.getAttribute('data-locale');
      if (dataLocale) {
        return dataLocale;
      }
    }

    const pathMatch = window.location.pathname.match(/^\/([a-z]{2})\//);
    if (pathMatch) {
      return pathMatch[1];
    }

    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("locale") || "";
  },
  getLimit: function () {
    const gridElement = document.querySelector('api-collection-grid');
    if (gridElement) {
      const limit = gridElement.getAttribute('data-limit');
      return limit ? limit : 16;
    }
  },
  shop: "bruderer.myshopify.com",
  limit: 16,
};

const TRANSLATIONS = {
  de: {
    // UI translations
    filter: "Filter",
    sort_by: "Sortieren nach",
    products_count: "{{ count }} Produkte",
    no_products: "Keine Produkte gefunden",
    add_to_cart: "Zum Warenkorb hinzufügen",
    sold_out: "Ausverkauft",
    quantity: "Anzahl",
    sale:"Sale",
    price_per_box: "CHF {{ price }}/Karton",

    // Filter labels
    filter_label_category: "Kategorien",
    filter_label_metafield_custom_fields_allergens: "Allergene",
    filter_label_metafield_custom_fields_product_certificates_list_v2: "Zertifikate",
    filter_label_metafield_custom_fields_product_certificates_new: "Zertifikate",
    filter_label_metafield_aico_metafields_gramatur_pro_stuck: "Grammatur/Stk",
    filter_label_metafield_aico_supplier: "Couvertüre Hersteller",
    filter_label_metafield_aico_metafields_schokolade: "Schokolade",
    filter_label_zutaten: "Zutaten",

    // Allergens
    "Gluten cereals": "Ohne glutenhaltige Getreide",
    Milk: "Ohne Milch",
    Soybeans: "Ohne Sojabohnen",
    "Tree nuts": "Ohne Schalenfrüchte",
    Vegan: "Vegan",

    // Zutaten
    "Mit Alkohol": "Mit Alkohol",
    "Mit Nüssen": "Mit Nüssen",

    // Zertifikate
    Bio: "Bio",
    Fairtrade: "Fairtrade",
    Halal: "Halal",
    Kosher: "Koscher",

    // Schokolade
    Dunkel: "Dunkel",
    Hell: "Hell",
    Weiss: "Weiss",

    // Sort options
    price_asc: "Preis, niedrig nach hoch",
    price_desc: "Preis, hoch nach niedrig",
    title_asc: "Alphabetisch, A-Z",
    title_desc: "Alphabetisch, Z-A",
    created_asc: "Älteste zuerst",
    created_desc: "Neueste zuerst",
    best_selling: "Relevanz",
    manual: "Empfohlen",
  },
  en: {
    // UI translations
    filter: "Filter",
    sort_by: "Sort by",
    products_count: "{{ count }} products",
    no_products: "No products found",
    add_to_cart: "Add to cart",
    sold_out: "Sold out",
    sale:'Sale',
    quantity: "Quantity",
    price_per_box: "CHF {{ price }}/Box",

    // Filter labels
    filter_label_category: "Categories",
    filter_label_metafield_custom_fields_allergens: "Allergens",
    filter_label_metafield_custom_fields_product_certificates_list_v2: "Certificates",
    filter_label_metafield_custom_fields_product_certificates_new: "Certificates",
    filter_label_metafield_aico_metafields_gramatur_pro_stuck: "Weight/Piece",
    filter_label_metafield_aico_supplier: "Chocolate Coating Manufacturer",
    filter_label_metafield_aico_metafields_schokolade: "Chocolate",
    filter_label_zutaten: "Ingredients",

    // Allergens
    "Gluten cereals": "Without gluten-containing grains",
    Milk: "Without milk",
    Soybeans: "Without soybeans",
    "Tree nuts": "Without nuts",
    Vegan: "Vegan",

    // Zutaten
    "Mit Alkohol": "With Alcohol",
    "Mit Nüssen": "With Nuts",

    // Zertifikate
    Bio: "Organic",
    Fairtrade: "Fairtrade",
    Halal: "Halal",
    Kosher: "Kosher",

    // Schokolade
    Dunkel: "Dark",
    Hell: "Milk",
    Weiss: "White",

    // Sort options
    price_asc: "Price, low to high",
    price_desc: "Price, high to low",
    title_asc: "Alphabetically, A-Z",
    title_desc: "Alphabetically, Z-A",
    created_asc: "Oldest first",
    created_desc: "Newest first",
    best_selling: "Best selling",
    manual: "Featured",
  },
  fr: {
    // UI translations
    filter: "Filtrer",
    sort_by: "Trier par",
    products_count: "{{ count }} produits",
    no_products: "Aucun produit trouvé",
    add_to_cart: "Ajouter au panier",
    sold_out: "Épuisé",
    sale:"Sale",
    quantity: "Quantité",
    price_per_box: "CHF {{ price }}/Boîte",

    // Filter labels
    filter_label_category: "Catégories",
    filter_label_metafield_custom_fields_allergens: "Allergènes",
    filter_label_metafield_custom_fields_product_certificates_list_v2: "Certificats",
    filter_label_metafield_custom_fields_product_certificates_new: "Certificats",
    filter_label_metafield_aico_metafields_gramatur_pro_stuck: "Poids/Pièce",
    filter_label_metafield_aico_supplier: "Fabricant de Couverture",
    filter_label_metafield_aico_metafields_schokolade: "Chocolat",
    filter_label_zutaten: "Ingrédients",

    // Allergens
    "Gluten cereals": "Sans céréales contenant du gluten",
    Milk: "Sans lait",
    Soybeans: "Sans soja",
    "Tree nuts": "Sans fruits à coque",
    Vegan: "Végétalien",

    // Zutaten
    "Mit Alkohol": "Avec Alcool",
    "Mit Nüssen": "Avec Noix",

    // Zertifikate
    Bio: "Bio",
    Fairtrade: "Fairtrade",
    Halal: "Halal",
    Kosher: "Casher",

    // Schokolade
    Dunkel: "Noir",
    Hell: "Au lait",
    Weiss: "Blanc",

    // Sort options
    price_asc: "Prix, croissant",
    price_desc: "Prix, décroissant",
    title_asc: "Alphabétique, A-Z",
    title_desc: "Alphabétique, Z-A",
    created_asc: "Plus ancien d'abord",
    created_desc: "Plus récent d'abord",
    best_selling: "Meilleures ventes",
    manual: "Recommandé",
  },
};

$(document).on('change', '.quantity__input[name="quantity_input"]', function () {
  let inputVal = parseInt($(this).val()) || 0;
  $(this).parents('.card__qty_buy_wrap').find('.quick-add').find('input[name="quantity"]').val(inputVal);
  console.log('inputVal',inputVal);
});

function t(key, replacements = {}) {
  const locale = API_CONFIG.getLocale() || "de"; // fallback to 'de'
  let translation =
      TRANSLATIONS[locale]?.[key] || TRANSLATIONS["de"][key] || key;

  // Replace placeholders like {{ count }}, {{ price }}, etc.
  Object.keys(replacements).forEach((placeholder) => {
    translation = translation.replace(
        `{{ ${placeholder} }}`,
        replacements[placeholder]
    );
  });

  return translation;
}

function getShopifyImageUrl(src, size) {
  if (!src) return "";

  const cleanSrc = src.split("?")[0];

  const lastDot = cleanSrc.lastIndexOf(".");
  const lastSlash = cleanSrc.lastIndexOf("/");

  if (lastDot > lastSlash) {
    const beforeExt = cleanSrc.substring(0, lastDot);
    const ext = cleanSrc.substring(lastDot);
    return `${beforeExt}_${size}${ext}`;
  }

  return cleanSrc;
}

class ApiCollectionGrid extends HTMLElement {
  constructor() {
    super();

    this.shop = API_CONFIG.getShop();
    this.collection = API_CONFIG.getCollection();
    this.locale = API_CONFIG.getLocale();
    this.limit = API_CONFIG.getLimit();

    this.products = [];
    this.filters = [];
    this.sorts = [];
    this.total = 0;
    this.pagination = {};
    this.menu = this.loadMenuData();

    this.allergenePattern = /vegan|glutenfrei|végétalien|sans gluten|gluten-free/i;
    this.zutatenPattern = /mit alkohol|mit nüssen|avec de l'alcool|avec des noix|with alcohol|with nuts/i;
    this.madeInPattern = /in der schweiz hergestellt/i;

    // Track facet values that should use certificates key (moved from certificates to allergens)
    this.certificateBasedAllergens = new Set();

    this.clearFiltersFromURL();

    const initialParams = window.location.search.slice(1);
    this.fetchFromAPI(initialParams, { skipFilters: false, skipSorts: false });
  }

  clearFiltersFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    let hasFilters = false;

    for (const [key] of urlParams.entries()) {
      if (key.startsWith('filter.') || key === 'sort' || key === 'page') {
        hasFilters = true;
        break;
      }
    }

    if (hasFilters) {
      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, '', cleanUrl);
    }
  }

  loadMenuData() {
    const menuDataScript = document.getElementById("collection-menu-data");
    if (!menuDataScript) {
      console.warn("Collection menu data not found");
      return [];
    }

    try {
      return JSON.parse(menuDataScript.textContent);
    } catch (e) {
      console.error("Failed to parse collection menu data:", e);
      return [];
    }
  }

  fetchFromAPI(searchParams = "", renderOptions = {}) {
    const params = new URLSearchParams();
    const formParams = new URLSearchParams(searchParams);

    params.set("shop", this.shop);

    const locale = this.locale;
    if(locale && locale !== '') params.set("locale", locale);

    const collection = this.collection;
    if (collection) params.set("collection", collection);

    const limit = this.limit;
    if (limit) params.set("limit", limit);

    if (formParams.has("q") && !collection) {
      params.set("q", formParams.get("q"));
    }

    if (formParams.has("sort")) {
      params.set("sort", formParams.get("sort"));
    }

    for (let [key, value] of formParams.entries()) {
      if (key.startsWith("filter.")) {
        const filterType = key.slice("filter.".length);

        // Check if this is an allergen that should be excluded
        if (filterType === API_CONFIG.metafields.allergens && API_CONFIG.excludeAllergens.has(value)) {
          // Use excludeMetafield parameter for exclusion
          params.append("excludeMetafield", `${API_CONFIG.metafields.allergens}:${value}`);
        }
        // Check if this is an allergen that originally came from certificates
        else if (filterType === API_CONFIG.metafields.allergens && this.certificateBasedAllergens.has(value)) {
          // Use the certificates custom field instead
          params.append(API_CONFIG.metafields.certificatesKey, value);
        } else {
          params.append(filterType, value);
        }
      }
    }

    if (formParams.has("page")) {
      params.set("page", formParams.get("page"));
    }

    const url = `${API_CONFIG.baseUrl}${
        API_CONFIG.endpoints.search
    }?${params.toString()}`;

    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`API Error: ${response.status}`);
          }
          return response.json();
        })
        .then((jsonData) => {
          this.products = jsonData.products || [];
          this.sorts = jsonData.availableSorts || [];
          this.total = jsonData.total || 0;
          this.pagination = jsonData.pagination || {};
          this.filters = this.transformFilters(jsonData.availableFilters || []);
          
          this.render(renderOptions);
        })
        .catch((error) => {
          console.error("[API] Fetch Error:", error);
        });
  }

  transformFilters(filters) {
    let allergensFilter = null;
    let allergensIndex = -1;
    let certificatesFilter = null;

    for (let i = 0; i < filters.length; i++) {
      if (filters[i].id === API_CONFIG.metafields.allergens) {
        allergensFilter = filters[i];
        allergensIndex = i;
      } else if (
          filters[i].id === API_CONFIG.metafields.certificates
      ) {
        certificatesFilter = filters[i];
      }

      if (allergensFilter && certificatesFilter) break;
    }

    if(!certificatesFilter) return filters;

    const facets = certificatesFilter.facets;
    if (facets) {
      const newZutatenFacets = {};

      for (const [key, value] of Object.entries(facets)) {
        if (this.madeInPattern.test(key)) {
          delete facets[key];
          continue;
        }

        if (allergensFilter && this.allergenePattern.test(key)) {
          allergensFilter.facets[key] = value;
          // Track that this value should use certificates key even though it's in allergens
          this.certificateBasedAllergens.add(key);
          delete facets[key];
          continue;
        }

        if (this.zutatenPattern.test(key)) {
          newZutatenFacets[key] = value;
          delete facets[key];
        }
      }

      if (Object.keys(newZutatenFacets).length > 0) {
        const newFilter = {
          id: certificatesFilter.id,
          enabled: true,
          label: "Zutaten",
          position: filters.length + 1,
          facets: newZutatenFacets,
        };

        filters.splice(allergensIndex + 1, 0, newFilter);
      }
    }

    // Recalculate counts for exclusion allergens (show remaining products, not products with allergen)
    if (allergensFilter && allergensFilter.facets) {
      const totalProducts = this.pagination?.total || this.total;
      for (const [key, value] of Object.entries(allergensFilter.facets)) {
        if (API_CONFIG.excludeAllergens.has(key)) {
          // For exclusion filters, show how many products will remain after excluding
          allergensFilter.facets[key] = totalProducts - value;
        }
      }
    }

    return filters;
  }

  render(options = {}) {
    const { skipFilters, skipSort } = options;

    if(this.products.length === 0) {
      this.renderNoProductFoundMessage();
      return;
    }

    this.renderProducts();
    aicoInitWishlistIcons();

    if (!skipFilters) {
      this.renderFilters();
    } else {
      // Even when skipping filters, update the 4 exclusion allergen counts
      this.updateExclusionAllergenCountsInDOM();
    }

    if(!skipSort) {
      this.renderSorts();
    }

    this.renderPagination();
    this.attachEventListeners();
  }

  updateExclusionAllergenCountsInDOM() {
    // Find the allergens filter in the transformed filters (already has calculated counts)
    const allergensFilter = this.filters.find(f => f.id === API_CONFIG.metafields.allergens);
    if (!allergensFilter || !allergensFilter.facets) return;

    // Update the display count for each exclusion allergen in the DOM
    API_CONFIG.excludeAllergens.forEach(allergenValue => {
      if (allergensFilter.facets[allergenValue] !== undefined) {
        const displayCount = allergensFilter.facets[allergenValue];

        // Update all checkboxes with this value to show the new count
        const checkboxes = this.querySelectorAll(
          `input[type="checkbox"][name="filter.${API_CONFIG.metafields.allergens}"][value="${allergenValue}"]`
        );

        checkboxes.forEach(checkbox => {
          const listItem = checkbox.closest('li');
          if (listItem) {
            // Hide the entire list item if remaining count is 0
            if (displayCount === 0) {
              listItem.style.display = 'none';
            } else {
              listItem.style.display = '';

              const label = checkbox.closest('label');
              if (label) {
                const countSpan = label.querySelector('.facet-checkbox__text');
                if (countSpan) {
                  // Find and update the count display (text in parentheses)
                  const textContent = countSpan.innerHTML;
                  const updatedContent = textContent.replace(/\(\d+\)/, `(${displayCount})`);
                  countSpan.innerHTML = updatedContent;
                }
              }
            }
          }
        });
      }
    });
  }

  renderNoProductFoundMessage() {
    const container = document.getElementById("product-grid");
    container.innerHTML = `<h2 class="title title--primary">${t("no_products")}</h2>`;
    document.querySelector(".pagination-wrapper").style.display = "none";
  }

  renderProducts() {
    const productGridContainer = document.getElementById("product-grid");
    const locale = API_CONFIG.getLocale();

    productGridContainer.innerHTML = `
      ${this.products
        .map((product) => {
          return `
            <li class="www grid__item">
                <div class="card-wrapper product-card-wrapper underline-links-hover" style="position: relative"> 
                    <div class="card card--standard card--media">
                        ${this.buildProductCardMarkup(product, locale)}
                    </div>
                </div>
            </li>`;
        })
        .join("")}
    `;
  }

  buildProductCardMarkup(product, locale) {
    let title = product.title;
    const title_fr = product.title_fr || title;
    const title_en = product.title_en || title;

    let description = product.description;
    const description_fr = product.description_fr || description;
    const description_en = product.description_en || description;

    if(this.locale === "fr" && title_fr) title = title_fr;
    if(this.locale === "en" && title_en) title = title_en;

    if(this.locale === "fr" && description_fr) description = description_fr;
    if(this.locale === "en" && description_en) description = description_en;
    
    const handle = product.handle || "";
    const mainImageSrc =
        product.images && product.images.length > 0 ? product.images[0].src : "";
    const mainImageAlt =
        product.images && product.images.length > 0
            ? product.images[0].alt
            : "Product image";

    const minPrice = Number(product.min_price); // Convert to number
    const formattedMinPrice = isNaN(minPrice) ? "0.00" : minPrice.toFixed(2);

    const productCurrency = product.currency || 'CHF';
    let compareAtPrice = product.variants[0].compareAtPrice || 0;
    let showCompareAtPrice = false;
    if (compareAtPrice > minPrice){
      showCompareAtPrice = true;
      compareAtPrice = Number(compareAtPrice);
    }

    const imageSrc300 = getShopifyImageUrl(mainImageSrc, "300x");
    const imageSrc600 = getShopifyImageUrl(mainImageSrc, "600x");
    const imageSrc900 = getShopifyImageUrl(mainImageSrc, "900x");

    // Build product URL with locale prefix (exclude 'de' as it's the default)
    const productUrl = (locale && locale !== 'de') ? `/${locale}/products/${handle}` : `/products/${handle}`;

    return `
      <div class="card__inner gradient ratio">
        ${
        mainImageSrc !== ""
            ? `
          <div class="card__media">
              <div class="media media--transparent media--hover-effect">
                  <a href="${productUrl}" class="full-unstyled-link">
                      <img
                        src="${imageSrc300}"
                        srcset="${imageSrc300} 300w, ${imageSrc600} 600w, ${imageSrc900} 900w"
                        sizes="(min-width: 990px) 264px, (min-width: 750px) 246px, calc(100vw - 3rem)"
                        alt="${mainImageAlt}"
                        width="300"
                        height="300"
                        loading="lazy"
                        class="motion-reduce">
                  </a>
              </div>
          </div>
        `
      : ""
    }
        
        ${this.buildProductAddToCartForm(product)}
        
        <div class="card__content">
            <div class="card__information">
                <h3 class="card__heading">
                    <a href="${productUrl}" class="full-unstyled-link">${title}</a>
                </h3>
            </div>
            <div class="card__badge bottom left">
            ${showCompareAtPrice?`
            <span class="badge price__badge-sale color-scheme-4">
              ${t("sale")}
            </span>
            `:''}
            </div>
        </div>
      </div>

      <div class="card__content">
        <div class="card__information">
            <h3 class="t1 card__heading h5">
                <a href="${productUrl}" class="full-unstyled-link">${title}</a>
                <div class="rte">
                    <div class="product__description description-wrap rte">
                        <div class="desc">${description}</div>
                    </div>
                    <p><b></b></p>
                </div>
            </h3>
            <div class="card-information">
                <div class="price${showCompareAtPrice?` price--on-sale price--show-badge`:''}">
                    <div class="price__container">
                        <div class="price__regular">
                            <span class="price-item price-item--regular">${t(
                                "price_per_box",
                                { price: formattedMinPrice }
                            )}</span>
                        </div>
                        ${showCompareAtPrice?`
                          <div class="price__sale">
                            <span class="visually-hidden visually-hidden--inline">Normaler Preis</span>
                            <span>
                              <s class="price-item price-item--regular">
                                ${productCurrency} ${compareAtPrice}
                              </s>
                            </span><span class="visually-hidden visually-hidden--inline">Verkaufspreis</span>
                          <span class="price-item price-item--sale price-item--last">
                            ${t(
                                "price_per_box",
                                { price: formattedMinPrice }
                            )}
                          </span>
                        </div>
                          `:''}
                    </div>
                </div>
            </div>
        </div>
        <div class="card__badge bottom left">
        ${showCompareAtPrice?`
        <span class="badge price__badge-sale color-scheme-4">
          ${t("sale")}
        </span>
        `:''}
        </div>
      </div>
      
      <div class="card__qty_buy_wrap">
        <div class="product-form__input product-form__quantity">
            <label class="quantity__label form__label">
                ${t("quantity")}
                <span class="quantity__rules-cart hidden">
                  <div class="loading__spinner hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>
                  
                  </div>
                  <span>(<span class="quantity-cart">0</span> im Warenkorb)</span>
                </span>
            </label>
            
            <div class="price-per-item__container">
              <quantity-input class="quantity" data-url="${productUrl}">
                <button class="quantity__button disabled" name="minus" type="button">
                  <span class="visually-hidden">Verringere die Menge für ${title}</span>
                  <span class="svg-wrapper">
                    <svg class="icon icon-minus" width="20" height="4" viewBox="0 0 20 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.375 2C19.375 2.29837 19.2565 2.58452 19.0455 2.79549C18.8345 3.00647 18.5484 3.125 18.25 3.125H1.75C1.45163 3.125 1.16548 3.00647 0.954505 2.79549C0.743526 2.58452 0.625 2.29837 0.625 2C0.625 1.70163 0.743526 1.41548 0.954505 1.2045C1.16548 0.993526 1.45163 0.875 1.75 0.875H18.25C18.5484 0.875 18.8345 0.993526 19.0455 1.2045C19.2565 1.41548 19.375 1.70163 19.375 2Z" fill="currentColor"></path>
                    </svg>
                  </span>
                </button>
                <input class="quantity__input" type="number" name="quantity_input" data-cart-quantity="0" data-min="1" min="1" step="1" value="1">
                <button class="quantity__button" name="plus" type="button">
                  <span class="visually-hidden">Erhöhe die Menge für ${title}</span>
                  <span class="svg-wrapper">
                    <svg width="20" height="20" class="icon icon-plus" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.375 10C19.375 10.2984 19.2565 10.5845 19.0455 10.7955C18.8345 11.0065 18.5484 11.125 18.25 11.125H11.125V18.25C11.125 18.5484 11.0065 18.8345 10.7955 19.0455C10.5845 19.2565 10.2984 19.375 10 19.375C9.70163 19.375 9.41548 19.2565 9.2045 19.0455C8.99353 18.8345 8.875 18.5484 8.875 18.25V11.125H1.75C1.45163 11.125 1.16548 11.0065 0.954505 10.7955C0.743526 10.5845 0.625 10.2984 0.625 10C0.625 9.70163 0.743526 9.41548 0.954505 9.2045C1.16548 8.99353 1.45163 8.875 1.75 8.875H8.875V1.75C8.875 1.45163 8.99353 1.16548 9.2045 0.954505C9.41548 0.743526 9.70163 0.625 10 0.625C10.2984 0.625 10.5845 0.743526 10.7955 0.954505C11.0065 1.16548 11.125 1.45163 11.125 1.75V8.875H18.25C18.5484 8.875 18.8345 8.99353 19.0455 9.2045C19.2565 9.41548 19.375 9.70163 19.375 10Z" fill="currentColor"></path>
                    </svg>
                  </span>
                </button>
              </quantity-input>
            </div>
        </div>
        
        ${this.buildProductAddToCartForm(product)}
      </div>
    `;
  }

  buildProductAddToCartForm(product) {    
    
    const variants = product.variants;
    const firstVariant = product.variants[0];    
    const firstVariantID = firstVariant.id; 
    const variant_inventory_management = firstVariant.inventoryItem?.tracked ? 'shopify' : '';
    
    const variantJSON = variants.map(v => {
      const inventory_policy = v.inventoryPolicy?.toLowerCase() || null;
      const inventory_management = v.inventoryItem?.tracked ? 'shopify' : null;

      return {
        id: v.id,
        title: v.title,
        sku: v.sku,
        available: v.availableForSale,
        inventory_quantity: v.inventoryQuantity,
        inventory_policy: inventory_policy,
        inventory_management: inventory_management
      };
    });


    return `
      <div class="quick-add no-js-hidden">
        <product-form class="product__info-container">
            <form method="post" action="${routes.cart_add_url}" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"> 
                <input type="hidden" name="form_type" value="product">
                <input type="hidden" name="utf8" value="✓">
                <input class="quantity__input hidden" type="number" name="quantity" data-cart-quantity="0" data-min="1" min="1" step="1" value="1" data-track="${variant_inventory_management}">
                <div class="product-form__error-message-wrapper" role="alert" hidden="">
                    <span class="svg-wrapper">
                        <svg class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.5" r="5.5" stroke="#fff" stroke-width="2"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width=".7"></circle><path fill="#fff" d="m5.874 3.528.1 4.044h1.053l.1-4.044zm.627 6.133c.38 0 .68-.288.68-.656s-.3-.656-.68-.656-.681.288-.681.656.3.656.68.656"></path><path fill="#fff" stroke="#EB001B" stroke-width=".7" d="M5.874 3.178h-.359l.01.359.1 4.044.008.341h1.736l.008-.341.1-4.044.01-.359H5.873Zm.627 6.833c.56 0 1.03-.432 1.03-1.006s-.47-1.006-1.03-1.006-1.031.432-1.031 1.006.47 1.006 1.03 1.006Z"></path></svg>
                    </span>
                    <span class="product-form__error-message"></span>
                </div>
                <input type="hidden" name="id" value="${firstVariantID}" class="product-variant-id">
                <script type="application/json" data-variant-data>
                  ${JSON.stringify(variantJSON)}
                </script>
                <button type="submit" name="add" class="quick-add__submit button button--full-width button--secondary" aria-haspopup="dialog" aria-live="polite" data-sold-out-message="true">
                    <span>${t("add_to_cart")}</span>
                    <span class="sold-out-message hidden">${t("sold_out")}</span>
                    <div class="loading__spinner hidden">
                      <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>
                    </div>                  
                </button>
                <input type="hidden" name="product-id" value="${product.id}">
                <input type="hidden" name="section-id" value="template--25104499507541__product-grid">
            </form>
          </product-form>
        </div>
    `;
  }

  renderFilters() {
    const desktopFiltersContainer = document.getElementById(
        "api-collection-filters-desktop"
    );

    const mobileFilterContainer = document.getElementById(
        "FacetsWrapperMobile"
    );

    const urlParams = new URLSearchParams(window.location.search);

    let desktopFilterGroupsMarkup = "";
    let mobileFilterGroupsMarkup = "";
    this.filters.forEach((filter, index) => {
      if (filter && filter.id && filter.facets && Object.keys(filter.facets).length > 0 && filter.id !== API_CONFIG.metafields.allergens) {
        desktopFilterGroupsMarkup += this.buildFilterGroup(filter, index, "desktop");
        mobileFilterGroupsMarkup += this.buildFilterGroup(filter, index, "mobile");
      }
    });

    desktopFiltersContainer.innerHTML = desktopFilterGroupsMarkup;

    mobileFilterContainer
        .querySelectorAll(".api-mobile-filter")
        .forEach((e) => e.remove());
    mobileFilterContainer.insertAdjacentHTML(
        "afterbegin",
        mobileFilterGroupsMarkup
    );

    this.restoreCheckedState(urlParams);

    this.updateClearFiltersLink(urlParams);
  }

  updateClearFiltersLink(urlParams) {
    let hasActiveFilters = false;
    for (const [key] of urlParams.entries()) {
      if (key.startsWith('filter.')) {
        hasActiveFilters = true;
        break;
      }
    }

    const clearFiltersLink = document.querySelector('.active-facets__button-remove');
    if (!clearFiltersLink) return;

    if (hasActiveFilters) {
      clearFiltersLink.style.display = 'block';
    } else {
      clearFiltersLink.style.display = 'none';
    }
  }

  restoreCheckedState(urlParams) {
    const allCheckboxes = this.querySelectorAll(
        'input[type="checkbox"][name^="filter."]'
    );
    allCheckboxes.forEach((checkbox) => {
      const filterValues = urlParams.getAll(checkbox.name);
      checkbox.checked = filterValues.includes(checkbox.value);
    });

    const currentCollection = this.collection;
    if (currentCollection && currentCollection !== "all") {
      const categoryCheckboxes = this.querySelectorAll(
          `input[type="checkbox"][name="filter.category"][value="${currentCollection}"]`
      );
      categoryCheckboxes.forEach((checkbox) => {
        checkbox.checked = true;
      });
    }
  }

  buildFilterGroup(filter, index, context) {
    if (filter.id === "price_range") return "";

    const facets = filter.facets;
    if (
        (!facets || Object.keys(facets).length === 0) &&
        API_CONFIG.getLocale() === "de"
    )
      return;

    const urlParams = new URLSearchParams(window.location.search);
    const activeValues = urlParams.getAll(`filter.${filter.id}`);
    let isOpen = activeValues.length > 0 || index === 0 ? "open" : "";

    let filterLabel = filter.label;
    if (filter.label === "Zutaten") {
      filterLabel = t("filter_label_zutaten");
    }

    return `
      <details class="${
        context === "desktop"
          ? "facets__disclosure-vertical api-desktop-filter"
          : "mobile-facets__details js-filter api-mobile-filter"
      }" ${isOpen}>
          <summary class="${
        context === "desktop"
            ? "facets__summary caption-large focus-offset"
            : "mobile-facets__summary focus-inset"
    }">
              <div>
                   <span>${filterLabel}</span>
                   ${
        context === "desktop"
            ? `
                       <svg class="icon icon-caret" width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.35402 0.146009C9.30758 0.0994456 9.2524 0.0625027 9.19165 0.0372962C9.13091 0.0120898 9.06579 -0.00088501 9.00002 -0.00088501C8.93425 -0.00088501 8.86913 0.0120898 8.80839 0.0372962C8.74764 0.0625027 8.69247 0.0994456 8.64602 0.146009L5.00002 3.79301L1.35402 0.146009C1.26013 0.0521222 1.1328 -0.000622839 1.00002 -0.000622839C0.867245 -0.000622839 0.739908 0.0521222 0.646021 0.146009C0.552135 0.239895 0.49939 0.367233 0.49939 0.500009C0.49939 0.632784 0.552135 0.760122 0.646021 0.854009L4.64602 4.85401C4.69247 4.90057 4.74764 4.93751 4.80839 4.96272C4.86913 4.98793 4.93425 5.0009 5.00002 5.0009C5.06579 5.0009 5.13091 4.98793 5.19166 4.96272C5.2524 4.93751 5.30758 4.90057 5.35402 4.85401L9.35402 0.854009C9.40058 0.807563 9.43753 0.752387 9.46273 0.691642C9.48794 0.630897 9.50091 0.565776 9.50091 0.500009C9.50091 0.434241 9.48794 0.36912 9.46273 0.308375C9.43753 0.24763 9.40058 0.192454 9.35402 0.146009Z" fill="currentColor"></path>
                       </svg>
                   `
            : `
                       <span class="mobile-facets__arrow">
                           <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-arrow" viewBox="0 0 14 10"><path fill="currentColor" fill-rule="evenodd" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546" clip-rule="evenodd"></path></svg>
                       </span>
                   `
    }
              </div>
          </summary>
          <div class="${
        context === "desktop"
            ? "parent-display facets__display-vertical"
            : "mobile-facets__submenu gradient"
    }">
              <div class="facets-wrap parent-wrap facets-wrap-vertical">
                  <ul class="facets-layout facets-layout-list facets-layout-list--text list-unstyled overflow-list ${
        context === "desktop"
            ? "facets__list--vertical"
            : "mobile-facets__list"
    }" role="list">
                      ${
        filter.facets
            ? (filter.id !== "collections" 
                ? Object.entries(filter.facets)
                  .map(([key, value]) => {
                    const isChecked = activeValues.includes(key)
                        ? "checked"
                        : "";
  
                    return this.buildFilterOptionMarkup(
                        filter.id,
                        key,
                        key,
                        value,
                        isChecked,
                        context
                    );
                  })
                  .join("") 
                : this.menu.map(menuItem => {
                    const normalizedMenuTitle = menuItem.title.trim().toLowerCase();

                    const matchingFacet = Object.entries(filter.facets).find(([facetKey, facetValue]) => {
                      return facetKey.trim().toLowerCase() === normalizedMenuTitle;
                    });

                    if(matchingFacet) {
                      const [facetKey, facetValue] = matchingFacet;
                      const isChecked = activeValues.includes(facetKey) ? "checked" : "";

                      return menuItem.handle !== this.collection ? this.buildFilterOptionMarkup(
                          filter.id,
                          facetKey,
                          menuItem.title,
                          facetValue,
                          isChecked,
                          context
                      ) : null;
                    }
                    return null;
                  })
                  .filter(Boolean)
                  .join("")
            )
            : ""
    }
                  </ul>
              </div>
          </div>
      </details>
    `;
  }

  buildFilterOptionMarkup(
      inputName,
      inputValue,
      key,
      value,
      isChecked,
      context
  ) {
    let translatedKey = key;
    if(inputName !== "metafield_aico_metafields_schokolade" && inputName !== "metafield_custom_fields_product_certificates_list_v2") translatedKey = t(key);
    const displayKey = translatedKey !== key ? translatedKey : key;

    return `
      <li class="${
        context === "desktop"
            ? "list-menu__item facets__item"
            : "mobile-facets__item list-menu__item"
    }">
          <label class="facets__label ${
        context === "desktop" ? "facet-checkbox" : "mobile-facets__label"
    }">
              <input type="checkbox" name="filter.${inputName}" value="${inputValue}" ${isChecked}>
              <svg width="16px" height="16px" viewBox="0 0 16 16"><rect width="16" height="16" fill="none" stroke="currentColor"></rect></svg>
              <div class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-checkmark" viewBox="0 0 12 9"><path fill="currentColor" fill-rule="evenodd" d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z" clip-rule="evenodd"></path></svg></div>
              <span class="facet-checkbox__text" aria-hidden="true">
                  <span class="facet-checkbox__text-label">${displayKey}</span>
                  ${value && value !== "" ? `(${value})` : ""}
              </span>
          </label>
      </li>
    `;
  }

  renderSorts() {
    const sortContainer = document.getElementById("SortBy");
    const sortMobileSelect = document.getElementById("SortBy-mobile");

    const urlParams = new URLSearchParams(window.location.search);
    const activeSort = urlParams.get("sort") || "";

    let sortOptionsMarkup = `<option value="">${t("best_selling")}</option>`;
    this.sorts.map((sort) => {
      const isSelected = activeSort === sort.id ? "selected" : "";
      sortOptionsMarkup += `<option value="${sort.id}" ${isSelected}>${sort.label}</option>`;
    });

    sortContainer.innerHTML = sortOptionsMarkup;
    sortMobileSelect.innerHTML = sortOptionsMarkup;
  }

  renderPagination() {
    document.querySelector(".pagination-wrapper").style.display = "block";
    const paginationContainer = document.querySelector(".pagination-wrapper");
    if (!paginationContainer) return;

    const hasNextPage = this.pagination.hasNextPage;
    const totalPages = this.pagination.totalPages;
    const hasPrevPage = this.pagination.hasPrevPage;
    const currentPage = this.pagination.currentPage;

    if (!hasNextPage && !hasPrevPage) {
      paginationContainer.innerHTML = "";
      return;
    }

    const pageNumbers = [];
    const range = 2;

    for (let i = 1; i <= totalPages; i++) {
      const isCurrentPage = i === currentPage;

      const showPage =
          i === 1 ||
          i === totalPages ||
          (i >= currentPage - range && i <= currentPage + range);

      if (showPage) {
        pageNumbers.push(`
          <li>
            <a href="#" class="pagination__item link ${
            isCurrentPage ? "pagination__item--current light" : ""
        }" data-page="${i}">
              ${i}
            </a>
          </li>
        `);
      } else if (
          (i === 2 && currentPage - range > 2) ||
          (i === totalPages - 1 && currentPage + range < totalPages - 1)
      ) {
        pageNumbers.push(`
          <li>
            <span class="pagination__item">...</span>
          </li>
        `);

        if (i === 2) {
          i = currentPage - range - 1;
        } else if (i === totalPages - 1) {
          i = totalPages - 1;
        }
      }
    }

    paginationContainer.innerHTML = `
      <nav class="pagination" role="navigation" aria-label="Page navigation">
        <ul class="pagination__list list-unstyled" role="list">
            ${
        hasPrevPage
            ? `
              <li>
                <a href="#" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce" data-page="${
                currentPage - 1
            }">
                    <span class="svg-wrapper">
                        <svg class="icon icon-caret" width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.35402 0.146009C9.30758 0.0994456 9.2524 0.0625027 9.19165 0.0372962C9.13091 0.0120898 9.06579 -0.00088501 9.00002 -0.00088501C8.93425 -0.00088501 8.86913 0.0120898 8.80839 0.0372962C8.74764 0.0625027 8.69247 0.0994456 8.64602 0.146009L5.00002 3.79301L1.35402 0.146009C1.26013 0.0521222 1.1328 -0.000622839 1.00002 -0.000622839C0.867245 -0.000622839 0.739908 0.0521222 0.646021 0.146009C0.552135 0.239895 0.49939 0.367233 0.49939 0.500009C0.49939 0.632784 0.552135 0.760122 0.646021 0.854009L4.64602 4.85401C4.69247 4.90057 4.74764 4.93751 4.80839 4.96272C4.86913 4.98793 4.93425 5.0009 5.00002 5.0009C5.06579 5.0009 5.13091 4.98793 5.19166 4.96272C5.2524 4.93751 5.30758 4.90057 5.35402 4.85401L9.35402 0.854009C9.40058 0.807563 9.43753 0.752387 9.46273 0.691642C9.48794 0.630897 9.50091 0.565776 9.50091 0.500009C9.50091 0.434241 9.48794 0.36912 9.46273 0.308375C9.43753 0.24763 9.40058 0.192454 9.35402 0.146009Z" fill="currentColor"></path>
                        </svg>
                    </span>
                </a>
              </li>
            `
            : ""
    }

            ${pageNumbers.join("")}

            ${
        hasNextPage
            ? `
              <li>
                <a href="#" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce" data-page="${
                currentPage + 1
            }">
                    <span class="svg-wrapper">
                        <svg class="icon icon-caret" width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.35402 0.146009C9.30758 0.0994456 9.2524 0.0625027 9.19165 0.0372962C9.13091 0.0120898 9.06579 -0.00088501 9.00002 -0.00088501C8.93425 -0.00088501 8.86913 0.0120898 8.80839 0.0372962C8.74764 0.0625027 8.69247 0.0994456 8.64602 0.146009L5.00002 3.79301L1.35402 0.146009C1.26013 0.0521222 1.1328 -0.000622839 1.00002 -0.000622839C0.867245 -0.000622839 0.739908 0.0521222 0.646021 0.146009C0.552135 0.239895 0.49939 0.367233 0.49939 0.500009C0.49939 0.632784 0.552135 0.760122 0.646021 0.854009L4.64602 4.85401C4.69247 4.90057 4.74764 4.93751 4.80839 4.96272C4.86913 4.98793 4.93425 5.0009 5.00002 5.0009C5.06579 5.0009 5.13091 4.98793 5.19166 4.96272C5.2524 4.93751 5.30758 4.90057 5.35402 4.85401L9.35402 0.854009C9.40058 0.807563 9.43753 0.752387 9.46273 0.691642C9.48794 0.630897 9.50091 0.565776 9.50091 0.500009C9.50091 0.434241 9.48794 0.36912 9.46273 0.308375C9.43753 0.24763 9.40058 0.192454 9.35402 0.146009Z" fill="currentColor"></path>
                        </svg>
                    </span>
                </a>
              </li>
            `
            : ""
    }
        </ul>
      </nav>
    `;

    this.attachPaginationListeners();
  }

  attachPaginationListeners() {
    const paginationLinks = document.querySelectorAll(
        ".pagination__item[data-page]"
    );
    paginationLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const page = link.getAttribute("data-page");
        this.handlePageChange(page);
      });
    });
  }

  handlePageChange(page) {
    const urlParams = new URLSearchParams(window.location.search);

    urlParams.set("page", page);

    const searchParams = urlParams.toString();

    this.updateURL(searchParams);

    window.scrollTo({ top: 0, behavior: "smooth" });

    this.fetchFromAPI(searchParams, { skipFilters: true, skipSort: true });
  }

  attachEventListeners() {
    if (this.filterChangeListener) {
      this.removeEventListener("change", this.filterChangeListener);
    }

    if (this.sortChangeListener) {
      const sortSelect = document.getElementById("SortBy");
      if (sortSelect && this.sortChangeListener) {
        sortSelect.removeEventListener("change", this.sortChangeListener);
      }
    }

    if (this.sortMobileChangeListener) {
      const sortMobileSelect = document.getElementById("SortBy-mobile");
      if (sortMobileSelect && this.sortMobileChangeListener) {
        sortMobileSelect.removeEventListener("change", this.sortMobileChangeListener);
      }
    }

    this.filterChangeListener = (e) => {
      if (e.target.matches('input[type="checkbox"][name^="filter."]')) {
        this.handleFilterChange(e);
      }
    };
    this.addEventListener("change", this.filterChangeListener);

    const sortSelect = document.getElementById("SortBy");
    if (sortSelect) {
      this.sortChangeListener = (e) => {
        this.handleSortChange(e);
      };
      sortSelect.addEventListener("change", this.sortChangeListener);
    }

    const sortMobileSelect = document.getElementById("SortBy-mobile");
    if (sortMobileSelect) {
      this.sortMobileChangeListener = (e) => {
        this.handleSortChange(e);
      };
      sortMobileSelect.addEventListener("change", this.sortMobileChangeListener);
    }
  }

  handleFilterChange(event) {
    if (event?.target) {
      const changedCheckbox = event.target;
      const allMatchingCheckboxes = this.querySelectorAll(
          `input[type="checkbox"][name="${changedCheckbox.name}"][value="${changedCheckbox.value}"]`
      );
      allMatchingCheckboxes.forEach((checkbox) => {
        checkbox.checked = changedCheckbox.checked;
      });
    }

    const searchParams = this.buildSearchParamsFromFilters();

    this.updateURL(searchParams);

    this.fetchFromAPI(searchParams, { skipFilters: true, skipSort: true });

    // Update clear filters link after filter change
    const urlParams = new URLSearchParams(searchParams);
    this.updateClearFiltersLink(urlParams);
  }

  handleSortChange(event) {
    const sortSelect = document.getElementById("SortBy");
    const sortMobileSelect = document.getElementById("SortBy-mobile");

    // Sync both dropdowns to have the same value
    if (event && event.target) {
      const selectedValue = event.target.value;
      if (sortSelect) sortSelect.value = selectedValue;
      if (sortMobileSelect) sortMobileSelect.value = selectedValue;
    }

    const searchParams = this.buildSearchParamsFromFilters();

    this.updateURL(searchParams);

    this.fetchFromAPI(searchParams, { skipFilters: true, skipSort: false });
  }

  buildSearchParamsFromFilters() {
    const params = new URLSearchParams();

    const filterMap = new Map();

    const filterCheckboxes = this.querySelectorAll(
        'input[type="checkbox"][name^="filter."]:checked'
    );
    filterCheckboxes.forEach((checkbox) => {
      const filterType = checkbox.name.slice("filter.".length);
      const value = checkbox.value;

      // Check if this is an allergen that originally came from certificates
      let finalName = checkbox.name;
      if (filterType === API_CONFIG.metafields.allergens && this.certificateBasedAllergens.has(value)) {
        // Use the certificates filter name instead
        finalName = `filter.${API_CONFIG.metafields.certificatesKey}`;
      }

      const key = `${finalName}::${value}`;
      if (!filterMap.has(key)) {
        filterMap.set(key, { name: finalName, value: value });
      }
    });

    filterMap.forEach((filter) => {
      params.append(filter.name, filter.value);
    });

    const sortSelect = document.getElementById("SortBy");
    if (sortSelect && sortSelect.value) {
      params.set("sort", sortSelect.value);
    }

    return params.toString();
  }

  updateURL(searchParams) {
    const newUrl = searchParams
        ? `${window.location.pathname}?${searchParams}`
        : window.location.pathname;

    window.history.pushState({ searchParams }, "", newUrl);
  }
}

customElements.define("api-collection-grid", ApiCollectionGrid);

